import { useMutation } from '@tanstack/react-query';
import { authAdacter } from 'adapters';
import { contextApp } from 'context';
import { generateRegexFromUrls, getItemFromStore, setItemToStore } from 'helpers/utils';
import { useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { urlsToCompare } from 'routes';
import { authService } from 'services';
import useErrors from './useErrors';

const useAuth = (fn, form) => {
 const { token } = useParams();
 const navigate = useNavigate();
 const { setError } = useErrors();
 const { state, pathname } = useLocation();
 const [isLoading, setIsLoading] = useState(true);
 const [formData, setFormData] = useState(form ?? null);

 const { auth, setAuth, setAllow, setRoutes, setLogout, configDispatch } = contextApp();
 const Auth = authService.useApiAuths(fn, token);
 const { mutate } = useMutation({ mutationFn: Auth[fn] });

 if (fn === 'signup' && !token) navigate('/authentication/card/register');

 const authenticate = (data, form, type = 'signin') => {
  setAuth({ ...data, login: true });
  setRoutes(data?.access.routes);
  setAllow(data?.access.permits);
  setItemToStore('sesion', data);
  const sessions = getItemFromStore('sessions', []);
  const isSession = sessions.findIndex(t => t.email === data.email);

  if (type === 'signin') {
   if (form?.remember && isSession < 0) sessions.unshift(data);
   else if (isSession > -1) sessions.splice(isSession, 1);
   setItemToStore('sessions', sessions);
   configDispatch({ type: 'RESTORE', payload: data?.company?.styles });
   toast.success(`Bienvenido ${data.fullName}`);
   setTimeout(setAuth, 2000, data);

   const allowedUrl = generateRegexFromUrls(urlsToCompare).some(e => e.test(pathname));
   if (!allowedUrl) return navigate(state?.restorePage || '/app/calendar', { state: { ...state, restorePage: null } });
   return;
  }

  if (isSession < 0) sessions.unshift(data);
  else if (isSession > -1) sessions.splice(isSession, 1);

  setItemToStore('sessions', sessions);
  configDispatch({ type: 'RESTORE', payload: data?.company?.styles });
  toast.success(`Bienvenido ${data.fullName}`);

  setTimeout(setAuth, 2000, data);
  return navigate('/app/calendar', { state: { ...state, restorePage: null } });
 };

 const handleSubmit = e => {
  e.preventDefault();
  mutate(authAdacter[fn](formData), {
   onSuccess: data => {
    /* if (fn === 'signup') {
     setAuth({ ...data, login: true });
     setRoutes(data?.access.routes);
     setAllow(data?.access.permits);
     setItemToStore('sesion', JSON.stringify(data));
     const sessions = getItemFromStore('sessions', []);
     const isSession = sessions.findIndex(t => t.email === formData.email);

     if (isSession < 0) sessions.unshift(data);
     else if (isSession > -1) sessions.splice(isSession, 1);

     setItemToStore('sessions', JSON.stringify(sessions));

     toast.success(`Bienvenido ${data.fullName}`);

     setTimeout(setAuth, 2000, data);
     return navigate('/app/calendar', { state: { ...state, restorePage: null } });
    } else if (fn === 'signin') {
     setAuth({ ...data, login: true });
     setRoutes(data?.access.routes);
     setAllow(data?.access.permits);
     console.log(data);
     setItemToStore('sesion', JSON.stringify(data));
     const sessions = getItemFromStore('sessions', []);
     const isSession = sessions.findIndex(t => t.email === formData.email);

     if (formData.remember && isSession < 0) sessions.unshift(data);
     else if (isSession > -1) sessions.splice(isSession, 1);
     setItemToStore('sessions', JSON.stringify(sessions));
     configDispatch({ type: 'RESTORE', payload: data?.company?.styles });
     toast.success(`Bienvenido ${data.fullName}`);
     setTimeout(setAuth, 2000, data);

     //  if (company !== data?.company?._id)
     //   return navigate('/' + data?.company?._id + '/app/calendar', { state: { ...state, restorePage: null } });

     const allowedUrl = generateRegexFromUrls(urlsToCompare).some(e => e.test(pathname));
     if (!allowedUrl) return navigate(state?.restorePage || '/app/calendar', { state: { ...state, restorePage: null } });
    } else */ if (fn === 'passForgot') {
     toast.success(`Se envía un correo electrónico a ${formData.email} con un enlace para restablecer la contraseña`);
     navigate('/authentication/card/confirm-mail');
    } else if (fn === 'passReset') {
     toast.success(`Inicie sesión con su nueva contraseña`);
     navigate('/authentication/card/login');
    } else if (fn === 'logout') {
     localStorage.removeItem('sesion');
     setLogout(data);
     setAuth(null);

     const allowedUrl = generateRegexFromUrls(urlsToCompare).some(e => e.test(pathname));

     if (!allowedUrl) return navigate('/authentication/card/logout');
    } else authenticate(data, formData, fn);
   },
   onError: err => console.log(err.response.data),
   onSettled: () => setIsLoading(false)
  });
 };

 const initGoogle = dataGoogle => {
  mutate(authAdacter[fn](dataGoogle), {
   onSuccess: data => {
    toast.success(`Bienvenido ${data.fullName}`);
    localStorage.setItem('sesion', JSON.stringify(data));
    navigate('/authentication/card/login');
   }
  });
 };

 const handleFieldChange = ({ target: { name, value, type, checked } }) => {
  setFormData({
   ...formData,
   [name]: type === 'checkbox' ? checked : value
  });
 };

 const validateLogin = (change = false, block = false, company = false) => {
  return mutate(change, {
   onSuccess: async data => {
    const newData = { ...auth, ...data };
    if (company) newData.login = true;
    setAuth(newData);
    setRoutes(data?.access.routes);
    setAllow(data?.access.permits);
    setItemToStore('sesion', newData);
    console.log({ company, newData, data, pathname });
    if (company) {
     configDispatch({ type: 'RESTORE', payload: data?.company?.styles });
     setTimeout(setAuth, 2000, data);
     const allowedUrl = generateRegexFromUrls(urlsToCompare).some(e => e.test(pathname));
     if (!allowedUrl) return navigate(state?.restorePage || '/app/calendar', { state: { ...state, restorePage: null } });

     toast.success(`Bienvenido a ${newData?.company?.name}`);
    }
    return;
   },
   onError: err => setError(err, block),
   onSettled: () => setIsLoading(false)
   //onSettled: (data, error, variables, context) => setIsLoading(false)
  });
 };

 return { handleFieldChange, handleSubmit, formData, initGoogle, authenticate, validateLogin, isLoading, setIsLoading };
};

export default useAuth;
